import React from 'react';
import Navigation from '../../components/auth/Navigation';

import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.element.isRequired
};

const AppLayout = ({ children, ...rest }) => {

  return (
    <div>
      {children}
      <Navigation />
    </div>
  );
};

AppLayout.propTypes = propTypes;

export default AppLayout;
